import React from "react";
import { Navbar, Nav } from "react-bootstrap";
import { ReactComponent as ArrowDownIcon } from "./images/arrow-down.svg";
import { RESUME_URL, RESUME_FILENAME, openResumePreview } from "./utils/Resume";

const LINKEDIN_URL = "https://www.linkedin.com/in/kuhuk/";

const Header = () => {
  const isAstronomy = window.location.pathname === "/astronomy";

  return (
    <Navbar
      className={`navbar-custom${isAstronomy ? " navbar-astronomy" : ""}`}
      fixed="top"
      expand="md"
    >
      <div className="brand-group">
        <Navbar.Brand href="/" className="brand-logo-text">
          Kuhuk
        </Navbar.Brand>
        <a
          href={LINKEDIN_URL}
          target="_blank"
          rel="noreferrer"
          className="open-to-work-badge"
        >
          <span className="open-to-work-dot" />
          open to work
        </a>
      </div>

      <Navbar.Toggle aria-controls="main-nav-collapse" className="nav-toggle" />

      <Navbar.Collapse id="main-nav-collapse">
        <Nav className="ms-auto nav-links align-items-md-center">
          <Nav.Link href="/">home</Nav.Link>
          <Nav.Link href="/coding">work</Nav.Link>
          <Nav.Link href="/astronomy">astro</Nav.Link>
          <Nav.Link href="/blog">writes</Nav.Link>
          <Nav.Link href="/contact_me">contact</Nav.Link>
          <Nav.Link
            href={RESUME_URL}
            download={RESUME_FILENAME}
            className="nav-resume-link"
            onClick={openResumePreview}
          >
            resume
            <ArrowDownIcon className="nav-resume-icon" />
          </Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Header;